import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { useNotificationTracking } from '../../../Util/Analytics';
import Content from '../Content';
import { Box, Flex, Text, ButtonOutlined } from '../../Base';

const Container = styled(Flex)`
  word-break: break-word;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const StyledButtonOutlined = styled(ButtonOutlined)(({ theme }) => ({
  backgroundColor: theme.colors.white,
  borderRadius: '8px',
}));

const TabContent = ({
  hidden,
  contents,
  onContentClick,
  t,
  onRedirectUrl,
  loading,
  hasMore,
  onLoadMore,
}) => {
  const { logNotificationItemClick } = useNotificationTracking();

  if (hidden) return <Fragment />;
  return (
    <Container flexDirection={'column'}>
      {contents &&
        contents.length > 0 &&
        contents.map((content) => {
          const {
            isNew,
            id,
            title,
            caption,
            rawContent,
            contentType,
            category,
            announcer,
            publishedTime,
            courseTitle,
            redirectUrl,
          } = content;
          return (
            <Content
              key={id}
              courseTitle={courseTitle}
              isNew={isNew}
              id={id}
              title={title}
              caption={caption}
              rawContent={rawContent}
              contentType={contentType}
              category={category}
              announcer={announcer}
              publishedTime={publishedTime}
              onNewItemClick={() => {
                logNotificationItemClick(`NEW: ${title}`);
                onContentClick?.();
              }}
              onItemClick={() => {
                logNotificationItemClick(title);
              }}
              redirectUrl={redirectUrl}
              onRedirectUrl={(redirect) => {
                onRedirectUrl(redirect);
                const notificationTitle = isNew ? `NEW: ${title}` : title;
                logNotificationItemClick(notificationTitle);
              }}
            />
          );
        })}
      {hasMore && (
        <StyledButtonOutlined m={4} onClick={onLoadMore} disabled={loading}>
          <Text textStyle={'body2'} fontWeight={'600'}>
            {loading ? t('LOADING_MORE') : t('LOAD_MORE')}
          </Text>
        </StyledButtonOutlined>
      )}
      {(!contents || contents.length === 0) && (
        <Box mt={2}>
          <Text textStyle={'subtitle1'} fontWeight={'light'} p={4} textAlign={'center'}>
            {t('NO_RESULT')}
          </Text>
        </Box>
      )}
    </Container>
  );
};

TabContent.propTypes = {
  hidden: PropTypes.bool,
  contents: PropTypes.array,
  onContentClick: PropTypes.func,
  onRedirectUrl: PropTypes.func,
  loading: PropTypes.bool,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
};

TabContent.defaultProps = {
  hidden: true,
  contents: [],
  onContentClick: null,
  onRedirectUrl: null,
  loading: false,
  hasMore: false,
  onLoadMore: null,
};

export default withTranslation('inbox')(TabContent);
